import React from "react";
import { Spinner } from 'reactstrap';
import "./loader.scss";
const LoaderUI = (
	{
		className = '',
		loader = true,
		overlay = false,
		FullWindow = true,
		color = 'primary',
		size = '',
		inContainer = false,
		message = false,
		loadingMessage=null
		
	}
) => (
	<>
		<div className={`loaderWrapper d-flex align-items-center justify-content-center 
            ${className} 
            ${FullWindow ? 'position-fixed' : inContainer ? 'position-absolute' : ''}
            `}>
			{
				overlay ? <span className={`loaderOverlay position-absolute`}></span> : null
			}
			{
				loader ?
					<div className="spinner-blc text-center">
						<Spinner color={color} size={size} className={`position-relative large `} />
						{
							message && <span className="d-block">{loadingMessage || "Loading Data..."}</span>
						}

					</div>
					: null
			}
		</div>
	</>
);

export default LoaderUI;